function compose(...args) {
  const comp = args.pop();

  return args.reverse().reduce((ret, cur) => {
    return cur(ret);
  }, comp);
}


export default compose;
